import { action, makeObservable, observable, reaction } from 'mobx';
import { freeBetStore } from '@pascal/pascal-core';
import { doBetStore } from './doBetStore';
import { winningStore } from './winningStore';
import { cardsStore } from './cardsStore';

class GameStore {
  isBetsClosed = false;

  roundStatus = 0;

  betId = 0;

  isAllowSendToInvoke = true;

  constructor() {
    makeObservable(this, {
      isBetsClosed: observable,
      roundStatus: observable,
      betId: observable,
      isAllowSendToInvoke: observable,
      setIsBetsClosed: action.bound,
      setRoundStatus: action.bound,
      setIsAllowSendToInvoke: action.bound,
      setBetId: action.bound,
      resetGameState: action.bound,
      handleClearRoundData: action.bound,
    });

    reaction(
      () => this.isBetsClosed,
      (value) => {
        freeBetStore.setIsAllowChangeFreeBet(!value);
      }
    );
  }

  setIsBetsClosed(arg) {
    this.isBetsClosed = arg;
  }

  setRoundStatus(status) {
    this.roundStatus = status;
  }

  setIsAllowSendToInvoke(bool) {
    this.isAllowSendToInvoke = bool;
  }

  setBetId(id) {
    this.betId = id;
  }

  handleClearRoundData() {
    this.isBetsClosed = false;
    this.roundStatus = 0;
    this.betId = 0;
  }

  resetGameState() {
    const { quickBets } = doBetStore;
    this.roundStatus = 0;
    this.isAllowSendToInvoke = true;
    this.setIsBetsClosed(false);
    winningStore.setLastWin(0);
    winningStore.clearWinInfo();
    cardsStore.setTableCards([]);
    winningStore.setWinCombination(null);
    doBetStore.setSelectedAmount([...quickBets].reverse()[0]);
  }
}

export const gameStore = new GameStore();
